import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import ContainerCard from "../ContainerCard";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      // backgroundColor: "white",
    },
  },
  card: {
    height: "35vh",
    // borderColor: theme.palette.primary.light,
    borderWidth: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  CardContent: {},
  description: {
    overflow: "hidden",
    display: "-webkit-box",

    // height: "22vh",
    textOverflow: "ellipsis",
    WebkitLineClamp: 7,
    WebkitBoxOrient: "vertical",
  },
  link: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(2),
  },
  CardHeader: {},
  CardHeaderTitle: {
    fontWeight: 600,
  },
}));

const AboutUs = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ContainerCard
        title={props.title}
        link={props?.link}
        linkTitle={props?.linkTitle}
      >
        <Typography variant="body1" className={classes.description}>
          {props?.description || "description"}
        </Typography>
      </ContainerCard>
    </div>
  );
};
export default AboutUs;
